import React from "react";
import { Outlet } from "react-router-dom";

import "./styles.scss";
import Navbar from "../../../components/DashboardNavbar";

const Dashboard: React.FC = () => {
  return (
    <div className="dashboard-container">
      <Navbar />
      <Outlet />
    </div>
  );
};

export default Dashboard;
